import styled from 'styled-components';
import { devices } from "../data/constants";
// import * as theme from "./Theme";


export const TableStyled = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin: 10px 0;
    border-radius: 8px;
`

export const TableHeaderStyled = styled.th`
    background-color: ${({ theme }) => theme.colors.activeColor};
    color: white;
    padding: 10px;
    text-align: left;
    font-size: 14px;
    @media only screen and ${devices.md} {
         width: ${({$size}) => `${$size}%`};
    }
   
`;

export const TableDataStyled = styled.td`
    padding: 8px;
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    background: ${({ theme }) => theme.colors.cardBG};
    color: ${({ theme }) => theme.colors.cardText};
    position: relative;
    @media only screen and ${devices.md} {
         width: ${({$size}) => `${$size}%`};
         font-size: 14px;
    }
`;

export const TableRowStyled = styled.tr`
    &:nth-child(even) {
        background-color: ${({ theme }) => theme.colors.opacityColor};
    }

    &:hover {
        background-color: ${({ theme }) => theme.colors.lightActiveHover};
    }
`;

// /* Table row styles */
// tr:nth-child(even) {
//     background-color: #f2f2f2;
// }

// tr:hover {
//     background-color: #e6f7ff;
// }